import { Validators } from '../../../../utils/validators';
import { FormModel } from '../../../../components/Form';
export const BookingMessageForm = (strings: any): FormModel[] => {
  return [
    {
      label: strings.bookingMessage_column_text,
      value: '',
      autoFocus: true,
      type: 'text',
      placeholder: '',
      field: 'template',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12 },
      required: true,
    },
  ];
};
